exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "mat-table.items-table .mat-cell.actions {\n  max-width: 80px;\n  text-align: right; }\n\nmat-table.items-table .mat-row.success {\n  background: lightgreen; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ContractsModule/ContractItemsTransferListComponent/contract-items-transfer-list.component.scss
// module id = ../../../../../src/ContractsModule/ContractItemsTransferListComponent/contract-items-transfer-list.component.scss
// module chunks = main